/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {DefaultLanding} from './DefaultLanding'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              {/* When the user lands here from /auth/login (just
                  authenticated), the URL is still /auth/* but the
                  authenticated branch has no /auth handler — without
                  this redirect PrivateRoutes catches it and dumps the
                  user on the 404 page. Send them through DefaultLanding
                  which picks the right home for their profile. */}
              <Route path='auth/*' element={<DefaultLanding />} />
              <Route path='/*' element={<PrivateRoutes />} />
              {/* Default landing — picks /dashboard for most users,
                  /manufacturer/stock for pure fabricante users who
                  don't have a company assigned. */}
              <Route index element={<DefaultLanding />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
